






































import VueSlickCarousel from 'vue-slick-carousel'
import { Component, Vue } from 'vue-property-decorator';
import {
  Getter,
} from 'vuex-class'
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

interface Candidate {
    ID: string;
    Name: string;
    Dropped: boolean;
}

@Component( {
    components: {
        VueSlickCarousel,
    }
})
export default class ElectionResults extends Vue {

    private results: {
        Candidate: Candidate;
        Count: number;
    }[][] = [];

    private includeAll = true;

    private carouselHack = 0;
    private stageIndex = 0;
    private alertText = '';

    private get totalVotes(): number {
        if (this.results.length == 0) {
            return 0;
        }
        const total = this.results[0].reduce( (sofar, c) => sofar + c.Count, 0);
        return total;
    }

    @Getter name;
    @Getter isAnonymous;
    private voteThreshold = 24;
    private get showResults() {
        if (!this.isAnonymous) {
            return true;
        }
        return this.totalVotes > this.voteThreshold;
    }

    private slickSettings = {
        "dots": true,
        "arrows": true,
        "dotsClass": "slick-dots custom-dot-class",
        "edgeFriction": 0.35,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "initialSlide": 0,
    }

    onCarouselChange(slideIndex: number) {
        this.slickSettings.initialSlide = slideIndex;
    }

    async updateResults() {
        try {
            const response = await this.$http.get(
                "/election/results",
                {
                    params: { all: this.includeAll }
                });
            this.results = response.data;
            this.slickSettings.initialSlide = Math.max(0,
                Math.min(this.slickSettings.initialSlide, this.results.length-1));
            this.carouselHack += 1;
        } catch (err) {
            this.alertText = err.response.data;
        }
    }

    mounted() {
        this.updateResults();
    }
}

